// extracted by mini-css-extract-plugin
export default {"heart":"style_heart__uCUxg","heartClicked":"style_heartClicked__WsNSD"};